import ErrorBoundaryWithLogger from 'components/common/ErrorBoundary/ErrorBoundary';
import { useAppSelector } from 'store/store';
import { footerClientLoadingSelector, footerTaxoLinkColumnsSelector } from 'store/selectors';
import FooterColumn from './FooterColumn';

const FooterColumnContainer = () => {
  const columns = useAppSelector(footerTaxoLinkColumnsSelector);
  const isLoading = useAppSelector(footerClientLoadingSelector);

  if (!columns && isLoading) {
    return null;
  }

  if (!columns) {
    throw new Error(
      'Homr did not return any "Footer Links" csvData content. Make sure the correct data is being returned! ',
    );
  }

  return (
    <ErrorBoundaryWithLogger componentId="Footer-FooterColumn">
      <FooterColumn columns={columns} />
    </ErrorBoundaryWithLogger>
  );
};

export default FooterColumnContainer;
